module.exports = __webpack_public_path__ + "img/appAsset--compliance--flow-destination--2-2--failed--yellow.116d11da.svg";